import { render, staticRenderFns } from "./creatMemorial.vue?vue&type=template&id=0a85aa2e&scoped=true&"
import script from "./creatMemorial.vue?vue&type=script&lang=js&"
export * from "./creatMemorial.vue?vue&type=script&lang=js&"
import style0 from "./creatMemorial.vue?vue&type=style&index=0&id=0a85aa2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a85aa2e",
  null
  
)

export default component.exports